// Askı sensörü hassasiyeti (1-10) → sapma sınırı ve kartın karar kuralı.
// Kaynak: d21j_askiKahve firmware/src/IOMap/hal.cpp (kart). Kart her ölçüm
// penceresinde ~50 örnek alır; örneğin pencere ortalamasından farkı sapma
// sınırını aşarsa "sapan", aşmazsa "düz" sayılır. ~2550 örnekte sayılar
// 0-255'e çevrilir (dev / flat). Karar: dev < 7 ve flat > 243 → kol yerinde.
// Sözleşme: BayinerIOT-Workspace- docs/api-contracts/hanger-sensor-live.md

export const MIN_HANGER_SENSITIVITY = 1;
export const MAX_HANGER_SENSITIVITY = 10;
export const DEFAULT_HANGER_SENSITIVITY = 5;

/** Hassasiyet 1..10 → sapma sınırı, ADC sayımı (dizin = hassasiyet - 1). */
export const HANGER_DEVIATION_LIMITS = [
  450, 380, 320, 280, 250, 220, 190, 160, 130, 100,
];

/** Karar sınırları (0-255 ölçeği). */
export const DEV_LIMIT = 7; // sapan bunun ALTINDA olmalı
export const FLAT_LIMIT = 243; // düz bunun ÜSTÜNDE olmalı
export const SCALE_MAX = 255;

/** [{ sensitivity, threshold }] — SensitivityScale ile aynı biçim. */
// Eski kart seti (OKC) askısı LED açık/kapalı FARKI ile ölçer (askı v0.4.4 /
// v0.4.6+): hassasiyet → fark eşiği; farkın ALTI = yerinde (WS#398).
// Askı v0.4.7: varsayılan (5) eşik 10 — tezgahta yuvada fark 0-6, kol
// önünde 13-15 (oldCardSet #79). Askı ve ekran tablosuyla aynı olmalı.
export const OKC_DIFF_THRESHOLDS = [18, 16, 14, 12, 10, 9, 8, 7, 6, 5];
export const okcDiffTable = () =>
  OKC_DIFF_THRESHOLDS.map((threshold, i) => ({ sensitivity: i + 1, threshold }));
/** OKC askısı fark modunda mı (yük `diff` taşır, `dev` yok). */
export const isOkcDiffMode = (live) =>
  !!live && live.diff !== undefined && (live.dev === null || live.dev === undefined);

export const hangerLimitTable = () =>
  HANGER_DEVIATION_LIMITS.map((threshold, i) => ({
    sensitivity: i + 1,
    threshold,
  }));

const isNum = (v) => typeof v === "number" && Number.isFinite(v);

/** Canlı yükteki geçerli hassasiyet (1-10), yoksa null. */
export const hangerSensitivityOf = (live) => {
  const v = Number.isInteger(live?.sensitivity)
    ? live.sensitivity
    : Array.isArray(live?.sensitivities) && Number.isInteger(live?.cup)
      ? live.sensitivities[live.cup - 1]
      : null;
  return Number.isInteger(v) &&
    v >= MIN_HANGER_SENSITIVITY &&
    v <= MAX_HANGER_SENSITIVITY
    ? v
    : null;
};

/**
 * Kartın kuralıyla karar: "in" (kol yerinde) / "out" (yerinde değil) /
 * null (değer yok).
 */
export const hangerDecision = (dev, flat) => {
  if (!isNum(dev) || !isNum(flat)) return null;
  return dev < DEV_LIMIT && flat > FLAT_LIMIT ? "in" : "out";
};
